import { createBrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import config from '@/config';

export function initSentry() {
  if (['production', 'test'].includes(config.release)) {
    Sentry.init({
      dsn: config.sentryDSN,
      environment: config.release,
      release: import.meta.env.VITE_APP_VERSION,
      integrations: [],
      tracesSampleRate: 0,
      sampleRate: 0.2,
      autoSessionTracking: false,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0.05,
      allowUrls: [
        /https?:\/\/founder\.scrambleup\.com/,
        /https?:\/\/localhost/,
      ],
      ignoreErrors: [
        /ChunkLoadError/,
        /Loading chunk \d+ failed/,
        /Loading CSS chunk \d+ failed/,
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        /Non-Error promise rejection captured/,
        /Network Error/,
        /Request aborted/,
        /timeout of \d+ms exceeded/,
        // Cross-origin iframe errors (Veriff, Google, etc.)
        /Blocked a frame with origin .* from accessing a cross-origin frame/,
        // reCAPTCHA noise
        /reCAPTCHA Timeout/,
        /Challenge cancelled by user/,
        /Challenge expired/,
        // Minified third-party errors (single/double letter after "Error: ")
        /^Error: [A-Za-z]{1,3}$/,
        // Third-party SDK errors
        'Error invoking postEvent: Method not found',
      ],
    });
  }
}

/** @type {typeof import('react-router-dom').createBrowserRouter} */
export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
